<script setup lang="ts">
import type { ComputedRef } from "vue";
import { SelectScrollUpButton, type SelectScrollUpButtonProps, useForwardProps } from "reka-ui";

const props = withDefaults(defineProps<SelectScrollUpButtonProps>(), {});
// Only the set props; typed as such (see HPixSelectArrow).
const forwarded = useForwardProps(props) as ComputedRef<SelectScrollUpButtonProps>;
</script>

<template>
  <SelectScrollUpButton v-bind="forwarded">
    <slot />
  </SelectScrollUpButton>
</template>
